import { merge } from 'lodash'
import types from '../actions/types'

const { UPDATE_STATEMENTS, RESET_STATEMENTS } = types

const initialState = {
  data: [],
  total: null,
  monthlyTotal: null,
  next: null,
  filter: {},
  updatedOn: null,
  hasNext: null,
  enviarExtratoEmail: false
}

function dashboardStatementsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_STATEMENTS: {
      return {
        ...state,
        data: merge([...state.data, ...action.data]),
        total: action.total,
        monthlyTotal: action.monthlyTotal,
        filter: action.filter,
        next: action.next,
        updatedOn: action.updatedOn,
        hasNext: action.hasNext,
        enviarExtratoEmail: action.enviarExtratoEmail
      }
    }
    case RESET_STATEMENTS: {
      return {
        ...state,
        data: [],
        filter: {},
        total: null,
        monthlyTotal: null,
        next: null,
        updatedOn: null,
        hasNext: null,
        enviarExtratoEmail: false
      }
    }
    default:
      return state
  }
}

export default dashboardStatementsReducer



// WEBPACK FOOTER //
// ./src/alelo-logic/reducers/dashboardStatementsReducer.js